import React from 'react';
import './NewsCard.css';

const NewsCard = ({ image, alt, category, categoryUrl, title, articleUrl, time }) => {
  // Determine the link based on card type
  const cardLink = categoryUrl || articleUrl || '#';
  
  return (
    <a href={cardLink} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
      <article className="news-card">
        <img src={image} alt={alt} loading="lazy" />
        <div className="card-content">
          <span className="category">{category}</span>
          <h3>{title}</h3>
          <time>{time}</time>
        </div>
      </article>
    </a>
  );
};

export default NewsCard;
